import { toQueryParamsString } from '../../utils/ApiUtils';
import { RequestType } from '../../interfaces/api/Request';
import { Order } from '../../interfaces/Table';

import { API_BASE_URL } from '../../env';
import { ApiReturnType } from '../../interfaces/api/api';

export default {
  getAll: (
    type: RequestType | 'all',
    orderBy: string,
    order: Order = 'asc',
    page = 1,
    limit = 10,
    status?: string
  ): ApiReturnType => ({
    endpoint: `${API_BASE_URL}/v2/request/requests${toQueryParamsString({
      type,
      page,
      limit,
      order,
      orderBy,
      status,
    })}`,
    headers: { 'Content-Type': 'application/json' },
    method: 'GET',
  }),
  get: (id: string): ApiReturnType => ({
    endpoint: `${API_BASE_URL}/v2/request/requests/${id}`,
    headers: { 'Content-Type': 'application/json' },
    method: 'GET',
  }),
  updateStatus: (id: string, status: string, closedReason?: string): ApiReturnType => ({
    endpoint: `${API_BASE_URL}/v2/request/requests/${id}/status`,
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ status, closedReason }),
    method: 'PATCH',
  }),
  updateIssueId: (id: string, issueId: string): ApiReturnType => ({
    endpoint: `${API_BASE_URL}/v2/request/requests/${id}/issues`,
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ issueId }),
    method: 'PATCH',
  }),
};
